const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class CompleteStyle extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slides?.exists || !this.els.slide?.exists) {
      return
    }

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 1.667,
          spacing: 2,
        },
        breakpoints: {
          '(max-width: 900px)': {
            disabled: true,
          },
          '(min-width: 901px)': {
            slides: {
              origin: 'auto',
              perView: 3,
              spacing: 2,
            },
          },
          '(min-width: 1101px)': {
            slides: {
              origin: 'auto',
              perView: 3,
              spacing: 2,
            },
          },
        },
        slideChanged: instance => {
          const activeSlide = instance.track.details.rel

          this.els.slide.elements.forEach(slideEl => {
            const parent = slideEl.parentNode
            const index = Array.prototype.indexOf.call(parent.children, slideEl)

            slideEl.classList.toggle(
              'prd-CompleteTheStyle_Item-active',
              index === activeSlide,
            )
          })
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.prev?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('complete-style')) {
  customElements.define('complete-style', CompleteStyle)
}
